module.exports = __webpack_public_path__ + "static/gallery_treehouse_4_thumb-3e9dcca7e0fb34a8dd07af9b8d70e5fd.jpg";